import {
  PROMO_CODE_ERROR_ATTRIBUTE,
  INVALID_PROMO_CODE_ERROR_CODE,
  CHARGE_PROCESSING_TYPE,
  DISCOUNT_PROCESSING_TYPE,
} from '~/javascripts/subscription/constants';

function isNamespaceEligibleForPurchase(namespace, excludedNamespaces) {
  return !excludedNamespaces.includes(namespace.id);
}

export function getAvailableNamespaces(namespaces, excludedNamespaces) {
  return Object.keys(namespaces).reduce((memo, type) => {
    // eslint-disable-next-line no-param-reassign
    memo[type] = namespaces[type]?.filter((namespace) =>
      isNamespaceEligibleForPurchase(namespace, excludedNamespaces),
    );

    return memo;
  }, {});
}

export function createNamespaceOptionGroup(text, namespaces = []) {
  return {
    text,
    options: namespaces.map((namespace) => ({
      value: namespace.id,
      text: namespace.namespaceNameWithPlan,
      secondaryText: `/${namespace.fullPath}`,
    })),
  };
}

export const isInvalidPromoCodeError = (errors) => {
  if (!errors || typeof errors !== 'object') {
    return false;
  }

  const { attributes = [], code } = errors;

  return attributes.includes(PROMO_CODE_ERROR_ATTRIBUTE) && code === INVALID_PROMO_CODE_ERROR_CODE;
};

export const getChargeItem = (invoiceItem) => {
  return invoiceItem?.find((item) => item.processing_type === CHARGE_PROCESSING_TYPE);
};

export const getDiscountItem = (invoiceItem) => {
  return invoiceItem?.find(
    (item) =>
      item.processingType === DISCOUNT_PROCESSING_TYPE ||
      item.processing_type === DISCOUNT_PROCESSING_TYPE,
  );
};
